export const noop = () => {
	// No operation function, does nothing
};
